export default "__VITE_ASSET__DJfezI7e__"